import { Box, Card, Typography } from "@mui/material";

export default function CardComponent({
  value,
  index,
  onClick,
  flipped,
  matched,
}) {
  const handleClick = () => {
    if (!flipped && !matched) {
      onClick(index);
    }
  };

  return (
    <Card
      role="button"
      data-testid="memory-card"
      aria-label="memory card"
      onClick={handleClick}
      sx={{
        position: "relative",
        aspectRatio: "1 / 1",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        borderRadius: 2,
        border: matched
          ? "2px solid rgba(114, 241, 184, 0.96)"
          : flipped
            ? "2px solid rgba(125, 249, 255, 0.96)"
            : "1px solid rgba(255,255,255,0.24)",
        background: matched
          ? "linear-gradient(160deg, rgba(30, 133, 100, 0.98), rgba(114, 241, 184, 0.96))"
          : flipped
            ? "linear-gradient(160deg, rgba(255, 255, 255, 0.99), rgba(211, 249, 255, 0.98))"
            : "linear-gradient(160deg, rgba(35, 92, 148, 0.98), rgba(16, 38, 68, 0.98))",
        cursor: flipped || matched ? "default" : "pointer",
        pointerEvents: flipped || matched ? "none" : "auto",
        boxShadow: matched
          ? "0 14px 24px rgba(114, 241, 184, 0.24)"
          : "0 14px 24px rgba(0, 0, 0, 0.2)",
        transform: flipped || matched ? "translateY(-4px)" : "translateY(0)",
        transition:
          "transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
        "&:hover": flipped || matched
          ? undefined
          : {
              transform: "translateY(-6px) scale(1.02)",
              boxShadow: "0 20px 40px rgba(0, 0, 0, 0.3)",
            },
      }}
    >
      {flipped || matched ? (
        <Box
          component="img"
          src={value}
          alt="Memory card"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background:
              "radial-gradient(circle at top, rgba(255,255,255,0.18), transparent 34%)",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontFamily: "'Arial Black', 'Trebuchet MS', sans-serif",
              color: "#fff176",
              textShadow: "0 4px 18px rgba(255, 241, 118, 0.36)",
            }}
          >
            ?
          </Typography>
        </Box>
      )}
      <Box
        aria-hidden="true"
        sx={{
          position: "absolute",
          inset: 8,
          borderRadius: 1.5,
          border: "1px solid rgba(255,255,255,0.12)",
          pointerEvents: "none",
        }}
      />
    </Card>
  );
}
